/* datas */
import { GetDateShortFR } from '../Functions/GetDates.js';
/* document */
import { GetBkgLogo } from '../Functions/GetBkgLogo.js';
import { LogoImgAttraction } from '../../../Files/LogoImgAttraction.js';
import { BlockLink } from '../Blocks/BlockLink.js';

export const BlockLogoFestival = (props) => {
    const item = props.item;
    const created = GetDateShortFR(item.created);
    const closed = GetDateShortFR(item.closed);
    const bkg = GetBkgLogo(item.pslug);
    const src = LogoImgAttraction('icon', item.cslug, item.aslug);
    return (
        <div className={`logo ${bkg}`}>
            <a className="icon" href={item.aroute} alt={item.aname} title={item.aname}>
                <img className="img" src={src} title={item.aname} alt={item.aname} loading="lazy" />
            </a>
            <div className="legend">
                <div className="title">{item.aname}</div>
                <div className="block-created">
                    <div className="created">{created}</div>
                    <div className="created">{closed}</div>
                </div>
                <BlockLink label="link-true" href={item.proute} name={item.pname} />
                <BlockLink label="link-true" href={item.croute} name={item.cname} />
            </div>
        </div>
    )
}